var productCardMarkup =
  `<div class="grid grid--uniform grid--collection small--grid--flush">
    {{#products}}
      <div class="grid__item grid-product small--one-half medium-up--one-fifth aos-init aos-animate" data-component="WishlistItem">
        <div class="grid-product__content">
          <a href="{{du}}" aria-label="{{dt}}" class="grid-product__link">
            <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <div class="grid-product__image-mask">
              <div class="grid__image-ratio grid__image-ratio--portrait lazyloaded">
                <img alt="{{dt}}" class="" src="{{iu}}">
              </div>
            </div>

            <div class="grid-product__meta">
              <div>
                <div class="grid-product__title grid-product__title--body" style="border-bottom: unset;">
                  {{dt}}
                </div>

                {{#cprops.type}}
                  <div class="grid-product__vendor">{{cprops.type}}</div>
                {{/cprops.type}}
              </div>
            </div>
          </a>
        </div>

        <div>
          <div class="custom_dropdown">
            {{#showDiscounts}}
              <select class="pproduct-single__variants" data-range-select>
                {{#cprops.discounts}}
                  <option value="{{value}}">{{label}}</option>
                {{/cprops.discounts}}
              </select>
            {{/showDiscounts}}

            <button
              id="swym-custom-add-toCartBtn"
              data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}"
              data-variant-id="{{epi}}"
              data-product-id="{{empi}}"
              data-product-quantity="1"
              data-add-to-cart
              class="add-to-cart"
            >
              {{submitLabel}}
            </button>
          </div>
        </div>
      </div>
    {{/products}}
  </div>`;

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

function swymRenderWishlist(swat) {
  const { addToCart, addedToCart } = window.theme.strings

  // Get wishlist items
  window._swat.fetch(function(products) {
    console.log(products, 'test');
    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
    var formattedWishlistedProducts = products.map(function(p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
      p.submitLabel = p.isInCart ? addedToCart : addToCart;

      if (p.cprops) {
        p.showDiscounts = !!p.cprops.discounts

        if (p.showDiscounts) {
          const discounts = p.cprops.discounts.reduce((acc, item) => {
            const rangeAndDiscount = item.split("/")
            const range = rangeAndDiscount[0].split("-")
            const rangeValue = range[0]
            const discountPercent = rangeAndDiscount[1].split("%")[0]

            const originalPrice = Math.round((parseFloat(p.pr, 10) * 100))
            const discountValue = originalPrice * (discountPercent / 100)
            const discountPrice = Math.round(originalPrice - discountValue)

            acc.push({
              value: rangeValue,
              label: `${rangeValue} pack - ${theme.Currency.formatMoney(
                discountPrice,
                theme.settings.moneyFormat
              )} ${discountValue !== 0 ? `(- ${rangeAndDiscount[1]})` : ''}`,
            })

            return acc
          }, [])

          p.cprops.discounts = discounts
        }
      }

      return p;
    });

    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts
    });

    if(wishlistContentsContainer){
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      attachClickListeners();
    } else{
      console.log("Container not found, Wishlist Page element not found");
    }

    document.dispatchEvent(new CustomEvent("wishlist:products:render"))
  });
}

function onAddToCartClick(e) {
  e.preventDefault();
  const { soldOut, addedToCart, adding } = window.theme.strings

  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var quantity = e.currentTarget.getAttribute("data-product-quantity") || 1;
  var du = e.target.getAttribute("data-product-url");

  e.target.innerHTML = adding;

  window._swat.replayAddToCart({
    empi: productId,
    du: du,
    qty: quantity,
  }, variantId, function(c) {
    e.target.innerHTML = addedToCart;
    e.target.setAttribute("data-state-cart", "swym-added");

    const cart = document.querySelector(".cart-link__bubble")
    if (!cart.className.includes("cart-link__bubble--visible")) {
      cart.classList.add("cart-link__bubble--visible")
    }

    console.log("Successfully added product to cart.", c);
  }, function(error) {
    e.target.innerHTML = soldOut;
    e.target.disable = true;
    console.log(error);
  });
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  //   Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }
  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
  }
  console.log("Events attached!");
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function(products) {
    products.forEach(function(product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function() {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  })
}
let productHandle = 'rave-freeze'
var productItem = '/products/' + productHandle + '?view=wishlist';
fetch(productItem).then(function (res) {
  if (res.status == 200){
    return res.text();
  }
}).then(function(data){
  //console.log(data)
})